import { createFileRoute } from '@tanstack/react-router'
import Publication from '../../components/Publications/Publication'
import CategoryPublications from '../../components/Categories/CategoryPublications'
import NotFound from '../../components/Common/NotFound'

export const Route = createFileRoute('/_layout/$slug')({
  component: SlugRouter,
  notFoundComponent: NotFound,
})

function SlugRouter() {
  const { slug } = Route.useParams()

  const isNumeric = /^\d+$/.test(slug)

  if (isNumeric) {
    return <Publication />
  }

  return <CategoryPublications />
}
